export enum AlertErrorKey {
  Unknown = 'UNKNOWN',
  InvalidEpc = 'INVALID_EPC',
  ScannerConfig = 'SCANNER_CONFIGURATION'
}


// WEBPACK FOOTER //
// ./src/types/alert-error-key.ts